import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b4f9ea56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calendar-day__inner" }
const _hoisted_2 = { class: "calendar-day__day" }
const _hoisted_3 = {
  key: 0,
  class: "calendar-day__price"
}
const _hoisted_4 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["calendar-day", {
          'is-selected-start-day' : _ctx.isSelectedStartDay,
          'is-selected-end-day' : _ctx.isSelectedEndDay,
          'is-disabled': _ctx.isDisabled,
          'is-in-range': _ctx.isInRange
        }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emit('selectDate',_ctx.day)))
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.getDay(_ctx.day.date)), 1),
      (_ctx.day.priceByPriceGroup && !_ctx.isDisabled)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " CHF " + _toDisplayString(_ctx.day?.priceByPriceGroup[_ctx.defaultPriceGroupId].price.toFixed(0)), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.day.discount)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "calendar-day__discount",
          "aria-label": _ctx.translate('shop.ticket.configuration.calendar.discount')
        }, "%", 8, _hoisted_4))
      : _createCommentVNode("", true)
  ], 2))
}